/* Advice Blog Block JS File */
$(document).ready(function() {

});
